var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (typeof _vm.amount === 'number')?_c('Amount',{attrs:{"decimals":_vm.displayedDecimals,"amount":_vm.amount,"currency":_vm.ticker,"currencyDecimals":_vm.currencyDecimals}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }